import script from "./DetalleCircuito.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetalleCircuito.vue?vue&type=script&lang=ts&setup=true"

import "./DetalleCircuito.vue?vue&type=style&index=0&id=82453bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82453bf4"]])

export default __exports__